import { render } from "./SightTable.vue?vue&type=template&id=816fdf48&scoped=true"
import script from "./SightTable.vue?vue&type=script&lang=js"
export * from "./SightTable.vue?vue&type=script&lang=js"

import "./SightTable.vue?vue&type=style&index=0&id=816fdf48&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-816fdf48"]])

export default __exports__